webpackJsonp([125701764692410],{

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';exports.__esModule = true;var _react = __webpack_require__(4);var _react2 = _interopRequireDefault(_react);
	__webpack_require__(446);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var
	
	Modifiers = function (_Component) {_inherits(Modifiers, _Component);function Modifiers() {_classCallCheck(this, Modifiers);return _possibleConstructorReturn(this, _Component.apply(this, arguments));}Modifiers.prototype.
	
	  render = function render() {
	    return (
	      _react2.default.createElement('div', { className: 'modifiers-page' },
	        _react2.default.createElement('h1', null, 'Modifiers'),
	        _react2.default.createElement('div', { style: { flex: 1, flexDirection: 'row' } },
	          _react2.default.createElement('div', { className: 'article' }, 'Modifiers are essentially shortcuts used to layout and style RNUILIB\'s components.',
	            _react2.default.createElement('br', null), 'They can be helpful when facing a new design or a complex layout by simplify the style prop composition.',
	
	            _react2.default.createElement('br', null), 'For example, when you want to align sub-components horizontally, instead of writing:',
	
	            _react2.default.createElement('pre', null, this.renderHTML('<View style={{flexDirection: \'row\'}}>')), ' you will use this ALIGNMENT modifier:',
	            _react2.default.createElement('pre', null, this.renderHTML('<View row>')), 'The \u2018row\u2019 modifier will simply change the view direction from its default direction (column) to a row, horizontal, direction.',
	
	            _react2.default.createElement('br', null), 'Another example is using this TYPOGRAPHY modifier:',
	
	            _react2.default.createElement('pre', null, this.renderHTML('<Text text10>Some text</Text>')), 'instead of writing this:',
	
	            _react2.default.createElement('pre', null, this.renderHTML('<Text style={{fontFamily: \'Helvetica\', fontSize: \'64\'}}>Some text</Text>')),
	            _react2.default.createElement('br', null), 'For closer look at the presets run the demo project on a mobile device or simulator.',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('span', null, ' See ', _react2.default.createElement('a', { href: 'https://medium.com/the-react-native-log/easy-layouting-with-react-native-b96c4c6fae7/' }, 'this'), ' blog post for an elaborate discussion.'),
	            _react2.default.createElement('h2', null, 'Style'),
	            _react2.default.createElement('div', null, 'The base foundation of each UI component is its style. We use basic style presets to define the rules and the style guide we follow. Our style presetes includes: Colors, Typography, Shadows, Border Radius and more.. You can easily use them anywhere in your code as you would have used any other constant value, or as a component modifier. You can also define your own presets and use them as you would the ui lib ones.',
	
	
	
	              _react2.default.createElement('br', null),
	              _react2.default.createElement('pre', null, this.renderHTML(
	                'Colors.loadColors({\n' +
	                '  pink: \'#FF69B4\',\n' +
	                '  gold: \'#FFD700\',\n' +
	                '});')),
	
	              _react2.default.createElement('pre', null, this.renderHTML('Typography.loadTypographies({ h1: {fontSize: 26, fontWeight: \'300\', lineHeight: 80}, });')),
	              _react2.default.createElement('span', null, 'To generate this text: ',
	                _react2.default.createElement('h1', { style: { color: '#FF69B4', fontSize: '26', display: 'inline' } }, 'Hello World'), ' use this line: ', _react2.default.createElement('pre', null, this.renderHTML('<Text h1 pink>Hello World</Text>')), _react2.default.createElement('br', null), 'It will use the h1 typography preset and the pink color preset to style the Text element.',
	                _react2.default.createElement('br', null), _react2.default.createElement('br', null), 'Our style presets are translated into modifiers that will help you create a stunning UI easily and quickly.'))),
	
	
	
	
	          _react2.default.createElement('div', null,
	            _react2.default.createElement('table', null,
	              _react2.default.createElement('tr', null,
	                _react2.default.createElement('th', null, 'Modifier'),
	                _react2.default.createElement('th', null, 'Description'),
	                _react2.default.createElement('th', null, 'Presets')),
	
	              _react2.default.createElement('tr', null,
	                _react2.default.createElement('td', null, 'Alignment'),
	                _react2.default.createElement('td', null, 'Aligns the component\'s content'),
	                _react2.default.createElement('td', null, 'row, column, spread, centerH, centerV, left, right, top, bottom')),
	
	              _react2.default.createElement('tr', null,
	                _react2.default.createElement('td', null, 'Flex'),
	                _react2.default.createElement('td', null, 'The way the component is stretches inside its parent'),
	                _react2.default.createElement('td', null, 'flex, flexGrow, flexShrink, flex-[value]')),
	
	              _react2.default.createElement('tr', null,
	                _react2.default.createElement('td', null, 'Margin'),
	                _react2.default.createElement('td', null, 'Component\'s margins'),
	                _react2.default.createElement('td', null, 'margin-[value], marginL-[value], marginR-[value], marginT-[value], marginB-[value]')),
	
	              _react2.default.createElement('tr', null,
	                _react2.default.createElement('td', null, 'Padding'),
	                _react2.default.createElement('td', null, 'Component\'s padding'),
	                _react2.default.createElement('td', null, 'padding-[value], paddingL-[value], paddingR-[value], paddingT-[value], paddingB-[value]')),
	
	              _react2.default.createElement('tr', null,
	                _react2.default.createElement('td', null, 'Colors'),
	                _react2.default.createElement('td', null, 'Can be used to specify a color anywhere needed, like for the component\'s text color.', _react2.default.createElement('br', null), 'For example: green10 = #00A65F'),
	
	
	                _react2.default.createElement('td', null, 'dark[10-80], blue[10-80], cyan[10-80], green[10-80], yellow[10-80], orange[10-80], red[10-80], purple[10-80], violet[10-80]')),
	
	
	              _react2.default.createElement('tr', null,
	                _react2.default.createElement('td', null, 'Background'),
	                _react2.default.createElement('td', null, 'Component\'s background color.', _react2.default.createElement('br', null), 'Use with a color value. For example: bg-red30'),
	                _react2.default.createElement('td', null, 'background-[color-value], bg-[color-value]')),
	
	              _react2.default.createElement('tr', null,
	                _react2.default.createElement('td', null, 'Typography'),
	                _react2.default.createElement('td', null, 'Component\'s font size. ', _react2.default.createElement('br', null), 'For example, text10 = 64 font size while text100 = 11 font size'),
	                _react2.default.createElement('td', null, 'text[10-100]')),
	
	              _react2.default.createElement('tr', null,
	                _react2.default.createElement('td', null, 'Border Radius'),
	                _react2.default.createElement('td', null, 'Component\'s border radius.'),
	                _react2.default.createElement('td', null, 'br[0-100]')),
	
	              _react2.default.createElement('tr', null,
	                _react2.default.createElement('td', null, 'Spacing'),
	                _react2.default.createElement('td', null, 'Component\'s spacing.'),
	                _react2.default.createElement('td', null, 's[1-10]')),
	
	              _react2.default.createElement('tr', null,
	                _react2.default.createElement('td', null, 'Shadows (for iOS)'),
	                _react2.default.createElement('td', null, 'Component\'s shadow, for dark or light backgrounds.'),
	                _react2.default.createElement('td', null, 'dark[10-40], white[10-40]')))))));
	
	
	
	
	
	
	  };Modifiers.prototype.
	
	  renderHTML = function renderHTML(text) {
	    return '' + text;
	  };return Modifiers;}(_react.Component);exports.default =
	
	
	Modifiers;module.exports = exports['default'];

/***/ }),

/***/ 446:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-modifiers-js-3a0195d5ea5c8eb5c6c8.js